<template>
<div>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox">
      <div class="ibox-title">
          <h5>Tasks</h5>
          <div class="ibox-tools">
              <a class="btn btn-primary btn-xs" data-toggle="modal" data-target="#add-task">Create new task</a>
          </div>
      </div>
      <div class="ibox-content">
        <task-modal></task-modal>
        <tasks-filters :listView="true"></tasks-filters>
        <tasks-lists></tasks-lists>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import TasksFilters from './Filters.vue'
import TasksLists from './List.vue'
import TaskModal from './AddTaskModal.vue'
import { useTaskStore } from '../../../../stores/TaskStore'

export default {
  setup () {
    const taskStore = useTaskStore()
    return { taskStore }
  },
  components: {
    tasksFilters: TasksFilters,
    tasksLists: TasksLists,
    taskModal: TaskModal
  },
  mounted () {
    document.title = 'Tasks :: PBN360 by Aphex Media'
    this.taskStore.loadTasks()
    this.$store.dispatch('loadUsers')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/Tasks.vue